const MONTH_INDEX = 4;
const MONTHS_PER_YEAR = 12;
function getMonthIndex(firstValidMonth, monthsInView) {
  if (!firstValidMonth || !monthsInView || !monthsInView.displayedFromMonth) {
    return 0;
  }
  const initialYear = firstValidMonth.slice(0, MONTH_INDEX);
  const targetYear = monthsInView.displayedFromMonth.slice(0, MONTH_INDEX);
  const initialMonth = Number(firstValidMonth.slice(MONTH_INDEX));
  const targetMonth = Number(monthsInView.displayedFromMonth.slice(MONTH_INDEX));
  const monthsApart = (targetYear - initialYear) * MONTHS_PER_YEAR;
  return targetMonth + monthsApart - initialMonth;
}
export default getMonthIndex;